var React = require('react');

function ArrowDown (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M12.0002 5.42893V19.5711","stroke":"currentColor","strokeWidth":"2","strokeLinecap":"round","strokeLinejoin":"round","key":0}),React.createElement("path",{"d":"M19.0713 12.5L12.0002 19.5711L4.92915 12.5","stroke":"currentColor","strokeWidth":"2","strokeLinecap":"round","strokeLinejoin":"round","key":1})]);
}

ArrowDown.defaultProps = {"viewBox":"0 0 24 25","fill":"none"};

module.exports = ArrowDown;

ArrowDown.default = ArrowDown;
